import { html } from "lit";

export const linkedinIcon = (theme: string) => html`
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    class="${theme === "purple" ? "twf-fill-white" : "twf-fill-[#282828]"}"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.633 13.633H11.2623V9.91998C11.2623 9.03457 11.2464 7.8948 10.0293 7.8948C8.79445 7.8948 8.60552 8.85943 8.60552 9.85549V13.6327H6.23482V5.99729H8.51069V7.04073H8.54261C9.006 6.24836 9.87081 5.77334 10.7881 5.80741C13.191 5.80741 13.634 7.388 13.634 9.44432L13.633 13.633ZM3.55983 4.95356C2.8051 4.95356 2.18376 4.33254 2.18376 3.57775C2.18376 2.82295 2.80481 2.20186 3.55954 2.20186C4.31421 2.20186 4.93519 2.82281 4.93533 3.57746C4.93533 4.33211 4.31442 4.95349 3.55983 4.95356ZM4.74518 13.633H2.37198V5.99729H4.74518V13.633ZM14.8149 0.000101554H1.18062C0.540609 -0.00712717 0.00780069 0.51334 0 1.1534V14.8453C0.00751442 15.4857 0.540251 16.0068 1.18062 15.9999H14.8149C15.4568 16.008 15.9914 15.487 16 14.8453V1.15247C15.9914 0.511049 15.4561 -0.00834388 14.8149 0.000101554Z"
    />
  </svg>
`;
